import React from "react"
import { useState } from "react"

const people = [
    {
      name: 'Multi Channel Contacts',
      title: 'Multi-Channel Contacts. Shopee Code League 2021 Data Analytics Challange',
      role: 'Finished',
      href1: 'https://github.com/vistokartika/multi-channel-contacts',
      href2: 'https://github.com/vistokartika/multi-channel-contacts',
      pages: '',
      imageUrl:
        'https://storage.googleapis.com/kaggle-competitions/kaggle/26187/logos/thumb76_76.png?t=2021-03-01-03-14-34',
    },
    {
        name: 'Address Element Extraction',
        title: 'Address Element Extraction. Shopee Code League 2021 Data Science Challenge',
        role: 'Finished',
        href1: 'https://github.com/vistokartika/address-element-extraction',
        href2: 'https://github.com/vistokartika/multi-channel-contacts',
        pages: '',
        imageUrl:
            'https://storage.googleapis.com/kaggle-competitions/kaggle/26187/logos/thumb76_76.png?t=2021-03-01-03-14-34',
    },
    {
        name: 'Teaming',
        title: 'A progressive web-app with the intention of helping people to find teams or activities available nearby',
        role: 'On Development',
        href1: 'https://github.com/vistokartika/timing',
        href2: 'https://teaming-teal.vercel.app/dashboard',
        pages: 'Github Pages',
        imageUrl:
        '/logo.jpg',
    },
    {
        name: 'Doto 2',
        title: 'Responsive website as Human Computer Interaction project, advertising a moba game called Doto 2',
        role: 'Finished',
        href1: 'https://github.com/vistokartika/doto-2',
        href2: 'https://vistokartika.github.io/doto-2/',
        pages: 'Github Pages',
        imageUrl:
        'https://raw.githubusercontent.com/vistokartika/doto-2/main/docs/Assets/Doto2-Logo.png',
    },
    {
        name: 'Tic-tac-toe',
        title: 'A recreation of one of the most popular 2 player turn-based game. Tic-tac-toe.',
        role: 'Finished',
        href1: 'https://github.com/vistokartika/tic-tac-toe',
        href2: 'https://github.com/vistokartika/multi-channel-contacts',
        pages: '',
        imageUrl:
        'https://img.poki.com/cdn-cgi/image/quality=78,width=600,height=600,fit=cover,g=0.5x0.5,f=auto/85535e05d1f130b16751c8308cfbb19b.png',
    },
    {
        name: 'House price prediction',
        title: 'A Machine Learning Project to predict house price and comparing various models.',
        role: 'Finisihed',
        href1: 'https://github.com/vistokartika/house-price-prediction',
        href2: 'https://github.com/vistokartika/multi-channel-contacts',
        pages: '',
        imageUrl:
        'https://storage.googleapis.com/kaggle-competitions/kaggle/5407/logos/thumb76_76.png',
    },
    {
        name: 'vistokartika.github.io',
        title: 'Personal portofolio of Benedictus Visto Kartika. Built using ReactJS',
        role: 'On Development',
        href1: 'https://github.com/vistokartika/vistokartika.github.io',
        href2: 'https://vistokartika.github.io/',
        pages: 'Github Pages',
        imageUrl:
        'https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png',
    },
    // {
    //     name: 'Jane Cooper',
    //     title: 'Paradigm Representative',
    //     role: 'Admin',
    //     href1: '#',
    //     href2: '#',
    //     imageUrl:
    //     'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
    // },
    // More people...
  ]

const Project = () => {
	const [isVisible, setstate] = useState(false)

	const toggleVisible = () => {
		setstate(!isVisible)
	}
    
	return (
        <><div className='w-full h-full flex flex-col place-items-center mt-12'>
            <div className='flex justify-between mb-8'>
                <div className='text-blue-400 text-4xl font-bold mt-16 underline'>Projects</div>
            </div>
        </div><ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 mb-8 ml-16 mr-16">

                {people.map((person) => (
                    <li
                        key={person.email}
                        className="col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200"
                    >
                        <div className="flex-1 flex flex-col p-8">
                            <img className="w-32 h-32 flex-shrink-0 mx-auto bg-black rounded-full" src={person.imageUrl} alt="" />
                            <h3 className="mt-6 text-gray-900 text-sm font-medium">{person.name}</h3>
                            <dl className="mt-1 flex-grow flex flex-col justify-between">
                                <dt className="sr-only">Title</dt>
                                <dd className="text-gray-500 text-sm">{person.title}</dd>
                                <dt className="sr-only">Role</dt>
                                <dd className="mt-3">
                                    <span className="px-2 py-1 text-green-800 text-xs font-medium bg-green-100 rounded-full">
                                        {person.role}
                                    </span>
                                </dd>
                            </dl>
                        </div>
                        <div>
                            <div className="-mt-px flex divide-x divide-gray-200">
                                <div className="w-0 flex-1 flex">
                                    <a
                                        href={person.href1}
                                        className="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
                                    >
                                        <span className="ml-3">Github Repository</span>
                                    </a>
                                </div>
                                <div className="-ml-px w-0 flex-1 flex">
                                    <a
                                        href={person.href2}
                                        className="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
                                    >
                                        <span className="ml-3">{person.pages}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul></>
	)
}

export default Project
